import { request } from '@/utils/request';

export function createVipOrder(data) {
  return request({
    url: '/order/create_vip_order',
    method: 'post',
    data,
  });
}